import { call, put, takeEvery } from "redux-saga/effects";
import { GET_LOGIN_SUCCESS, GET_LOGIN_FAILED, GET_LOGIN_REQUESTED, GET_MAGICTOKEN_SUCCESS, GET_MAGICTOKEN_FAILED, GET_MAGICTOKEN_REQUESTED, GET_TOKENVERIFY_SUCCESS, GET_TOKENVERIFY_FAILED, GET_TOKENVERIFY_REQUESTED } from "resources/actionTypes";
import { loginApi } from "services/LoginService";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import store from "redux/store";
import { getProfile } from "redux/actions/UserProfile";
import { fetchRolesAndPermissions } from "redux/actions/RolesAndPermissionsAction";

function* fetchLogin(action) {
  const payload = action.payload || {}
  const userLogin = yield call(loginApi, payload?.userLogin?.userDetails);
  if (userLogin.success) {
    yield put({ type: GET_LOGIN_SUCCESS, userLogin: userLogin });


    if (payload?.userLogin?.actionType === "login") {
      payload?.setOnOtp(true);
      localStorage.setItem('mobile', payload?.userLogin?.userDetails?.mobileOrEmail);
      localStorage.setItem('code', payload?.userLogin?.userDetails?.countryCode);
    }

    localStorage.setItem('secretToken', userLogin.data[0].otpSecret)
    toast.success(userLogin.message);
  } else {
    yield put({ type: GET_LOGIN_FAILED, message: userLogin.message });
    toast.error(userLogin.message || 'Login failed');
  }
}
export function* loginSaga() {
  yield takeEvery(GET_LOGIN_REQUESTED, fetchLogin);
}


function* fetchMagicToken(action) {
  const token = localStorage.getItem('token')
  let url = `${process.env.REACT_APP_B2B_DOMAIN + '/login?Token=' + token}`
  window.open(url, "_blank")
  store.dispatch(fetchRolesAndPermissions('auth'));
  store.dispatch(getProfile('auth'));
}
export function* magicTokenSaga() {
  yield takeEvery(GET_MAGICTOKEN_REQUESTED, fetchMagicToken);
}
